// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EMcX","importantInfo":"styles_importantInfo__29Y5c"};